import React, { useEffect, useRef } from "react"

import { Col, Container, Row } from "reactstrap"

// import userImage from "../../assets/images/user-img.png"
// import profileBanner from "../../assets/images/profile-banner.png"
import UpdateProfile from "./updateProfile"
import {
  useInvestorProfileUpdateMutation,
  useWhealthProfileUpdateMutation,
} from "store/api/investorapi/auth.api"
import { useDispatch, useSelector } from "react-redux"
import { setAvatar } from "store/slices/userSlice"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"
import { getAbbreviation } from "helpers/common"
import RefferalInfo from "./RefferalInfo"

const Profile = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const imgRef = useRef(null)
  const { user, userType } = useSelector((state) => state?.user)
  const [investorUploadImage, { isLoading }] =
    useInvestorProfileUpdateMutation()
  const [wealthUploadImage, { isLoading: isLoadingWealth }] =
    useWhealthProfileUpdateMutation()

  // const getKycData = async () => {
  //   try {
  //     const { success, data } = await getResult().unwrap()
  //     if (success) {
  //       setKycData(data)

  //       dispatch(
  //         setLoginUserData({
  //           user: {
  //             ...user,
  //             phone: data.phone,
  //             email: data.email,
  //             kyc_status: data.kyc_status,
  //           },
  //         })
  //       )
  //     }
  //   } catch (error) {}
  // }

  useEffect(() => {
    if (userType && userType === "ADMIN") {
      navigate("/platform-manager/system-configuration")
    }
  }, [userType])

  const uploadPic = async (image) => {
    try {
      const { success, data, message } =
        userType === "INVESTOR"
          ? await investorUploadImage(image).unwrap()
          : await wealthUploadImage(image).unwrap()
      if (success) {
        dispatch(setAvatar({ avatar: data.image }))
        toast.success(message, { id: "uploadProfileSuccess" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      uploadPic(file)
    }
  }

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* <div className="profile-banner-wrapper">
            <img src={profileBanner} alt="" width={"100%"} />
          </div> */}
          <div className="profile-content-section pt-5 mt-5">
            <Row>
              <Col xl={12}>
                <div className="profile-upload-section">
                  <div className="user-profile">
                    {user?.avatar_url ? (
                      <img
                        className="profile-image"
                        src={user?.avatar_url}
                        alt=""
                        style={{
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "160px",
                          minWidth: "160px",
                          height: "160px",
                          minHeight: "160px",
                          border: "4px solid #fff",
                          backgroundColor: "#fff",
                          padding: "3px",
                          borderRadius: "50%",
                          color: "#000",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          boxShadow: "0px 12px 16px -4px rgba(0, 0, 0, 0.2)",
                          fontSize: "50px",
                          fontWeight: "500",
                        }}
                      >
                        {getAbbreviation(
                          user.user_type === "SUB_INVESTOR"
                            ? user?.uname
                            : user?.name
                        )}
                      </div>
                    )}
                    <input
                      ref={imgRef}
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      style={{ display: "none" }}
                    />
                    {/* <div
                      className="upload-icon"
                      onClick={() => {
                        if (imgRef?.current) {
                          imgRef.current.click()
                        }
                      }}
                    >
                      {isLoading || isLoadingWealth ? (
                        <Spinner color={"light"} size={"sm"} />
                      ) : (
                        <img src={camera} alt="" />
                      )}
                    </div> */}
                  </div>
                  <div className="user-name">
                    <h4>
                      {user.user_type === "SUB_INVESTOR"
                        ? user?.uname
                        : user?.name}
                    </h4>
                    <p>{user?.email}</p>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="">
              {/* <Col xl={12}>
                <div className="profile-tab-wrapper-section">
                  {tabs.map((tab) => {
                    return (
                      <div
                        key={tab}
                        className="tab-box"
                        onClick={() => setActiveTab(tab)}
                      >
                        <p className={activeTab === tab ? "active" : ""}>
                          {tab}
                        </p>
                      </div>
                    )
                  })}
                </div>
              </Col> */}
              <div className="profile-tab-content-section mt-4">
                <UpdateProfile userType={userType} userDetails={user} />
              </div>
              {userType === "WEALTH_PARTNER" && (
                <div className="profile-tab-content-section mt-4">
                  <RefferalInfo userType={userType} userDetails={user} />
                </div>
              )}
            </Row>
          </div>
        </Container>
      </div>
    </>
  )
}

export default Profile
